import React from 'react';
import PropTypes from 'prop-types';

import { Text } from '@playbookux/playbook-web-core';
import {
  Button,
  ButtonContainer,
  Container,
  Content,
  Context,
  ContextComponent,
  Header,
} from './styles';

const StudyContext = ({ studyContext, onStartRecording }) => (
  <Container>
    <ContextComponent>
      <Header>
        <Text.Header>
          Study Context
        </Text.Header>
      </Header>

      <Content>
        <Context>{studyContext}</Context>

        <ButtonContainer>
          <Button onClick={onStartRecording}>
            Start Recording
          </Button>
        </ButtonContainer>
      </Content>
    </ContextComponent>
  </Container>
);

StudyContext.propTypes = {
  studyContext: PropTypes.string.isRequired,
  onStartRecording: PropTypes.func.isRequired,
};

export default StudyContext;
